import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { BsArrowRight } from 'react-icons/bs';

import { Link } from 'common/components/Link/animated';
import { IProjectItemOverview } from 'common/types/projects';

export const WorkProjectItem: React.FC<{ project: IProjectItemOverview }> = ({ project }) => {
  const { t } = useTranslation('common');
  const { imageHomepage, title, slug } = project;

  return (
    <article
      key={slug}
      className="group relative flex flex-col justify-between overflow-hidden border-[1px] border-white/10 bg-[#261434]">
      <Link href={slug}>
        <div className="flex min-h-[50svh] items-end justify-end overflow-hidden lg:h-[340px]">
          <Image
            src={imageHomepage.src}
            className="h-full object-cover"
            alt=""
            height={imageHomepage.height}
            width={imageHomepage.width}
          />
        </div>
        <div
          className={clsx('absolute bottom-0 left-0 right-0 top-0', {
            'bg-gradient-to-br from-[#15224366] to-[#0035AD66] text-white':
              project.color === 'blue',
            'bg-gradient-to-br from-[#93551366] to-[#bc8c5c66] text-white':
              project.color === 'yellow',
            'bg-gradient-to-br from-[#a0000066] to-[#D0181866] text-white': project.color === 'red',
            'bg-gradient-to-br from-[#3f1d5666] to-[#6D547D66] text-white':
              project.color === 'purple',
          })}>
          <div
            className={clsx(
              'absolute bottom-0 left-[50%] top-0 w-0  opacity-0 transition-all duration-500 lg:group-hover:w-[102%] lg:group-hover:-translate-x-[50%] lg:group-hover:opacity-80',
              {
                'bg-[#152243]': project.color === 'blue',
                'bg-[#935513]': project.color === 'yellow',
                'bg-[#a00000]': project.color === 'red',
                'bg-[#3f1d56]': project.color === 'purple',
              },
            )}
          />
        </div>
        <div
          className={clsx(
            'absolute bottom-0 left-0 right-0 top-0 flex flex-col justify-between p-6 md:p-12',
          )}>
          <h2
            className="text-heading-item mb-1 max-w-xl pt-4 font-bold text-white"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div className="opacity-1 mt-5 flex items-center transition-all duration-300 lg:opacity-0 lg:group-hover:opacity-100">
            {t('common:readMore')}{' '}
            <BsArrowRight
              className="ml-6 mt-1 transition-all duration-300 lg:ml-3 lg:group-hover:ml-6"
              size={20}
            />
          </div>
        </div>
      </Link>
    </article>
  );
};
